import React, { useRef, useEffect } from 'react';
import { timeDateFormat } from '../../../utils/multiuseFunctions';
import './notificationsList.css';

const NotificationBellIcon = ({ count }) => {
  return (
    <div className='notification-icon-wrapper'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        viewBox='0 0 16 22'
        fill='#00FF86'
      >
        <path
          d='M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z'
          fill='#00FF86'
        />
        <path
          d='M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z'
          fill='#00FF86'
        />
      </svg>
      {count > 0 && <span className='notification-badge'>{count}</span>}
    </div>
  );
};

const NotificationItem = ({ item, dismiss, handleNavigate }) => {
  const getStatusInfo = (status) => {
    const statusMap = {
      aiconfirmed: { text: 'AI Approved', className: 'ai-approved' },
      confirmed: { text: 'Approved', className: 'approved' },
      rejected: { text: 'Denied', className: 'denied' },
      default: { text: 'Pending', className: 'pending' },
    };
    return statusMap[status] || statusMap.default;
  };

  const statusInfo = getStatusInfo(item.status);

  return (
    <div className='notification-item'>
      <div className='notification-content'>
        <div className='notification-header'>
          <h4 className='notification-title'>
            {item.headingMessage}
            <span
              className='navigation-icon'
              onClick={() => handleNavigate(item?.page)}
              title='Go to page'
            >
              ↗
            </span>
          </h4>
          {!item.seen && <span className='unread-indicator' />}
        </div>

        <div className='notification-body'>
          {item.message && (
            <p className='notification-message'>{item.message}</p>
          )}

          {item.headingMessage !== 'Support Message' && (
            <span className={`status ${statusInfo.className}`}>
              {statusInfo.text}
            </span>
          )}

          <span className='notification-time'>{timeDateFormat(item.time)}</span>
        </div>
      </div>

      <div className='notification-actions'>
        <button
          className='dismiss-button'
          onClick={() => dismiss(item.notificationId)}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

const NotificationsList = ({
  notifications,
  showNotification,
  setShowNotification,
  count,
  totalCount,
  skip,
  fetchMoreData,
  dismiss,
  notificationLoader,
  handleNavigate,
  dismissAll,
  handleNotificationToggle,
}) => {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowNotification]);

  return (
    <div className='notifications-list-container' ref={dropdownRef}>
      <div
        className='notification-trigger'
        onClick={() => handleNotificationToggle()}
      >
        <NotificationBellIcon count={count} />
      </div>

      {showNotification && (
        <div className='notifications-list'>
          <div className='notifications-header'>
            <h3>Notifications</h3>
            <button className='dismiss-all-button' onClick={dismissAll}>
              Dismiss All
            </button>
          </div>

          <div
            className={`notifications-content ${
              notificationLoader ? 'loading' : ''
            }`}
          >
            {notificationLoader ? (
              <div className='loading-spinner'>Loading...</div>
            ) : notifications.length > 0 ? (
              <>
                <div className='notifications-items'>
                  {notifications.map((item, index) => (
                    <NotificationItem
                      key={index}
                      item={item}
                      dismiss={dismiss}
                      handleNavigate={handleNavigate}
                    />
                  ))}
                </div>

                {totalCount > 6 && skip < totalCount && (
                  <div className='load-more-container'>
                    <button
                      className='load-more-button'
                      onClick={fetchMoreData}
                    >
                      View More
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className='no-notifications'>No new notifications</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationsList;
